import { dataLayer } from '@dpgradio/creative'
import { defineStore } from 'pinia'

export const useBuzzerStore = defineStore('BuzzerStore', {
  state: () => ({
    hasRecentDetection: false,
    isSigningUp: false,
  }),
  actions: {
    async signUp() {
      if (this.isSigningUp || this.hasRecentDetection) {
        return
      }
      try {
        this.isSigningUp = true
        await fetch('https://counter.radio.dpgmedia.cloud/toetjesdag25', {
          method: 'POST'
        })

        this.hasRecentDetection = true
        dataLayer.pushCampaignAction('click')

        setTimeout(() => {
          this.hasRecentDetection = false
        }, 60000)
      } catch (e) {
        throw e
      } finally {
        this.isSigningUp = false
      }
    },
  },
})
